
<!DOCTYPE html>
<html>
<head>
  <style>
    html, body {
      height: 100%;
      margin: 0;
      padding: 0;
    }

    /* Make the page a vertical stack: header at top, content fills the rest */
    body {
      display: flex;
      flex-direction: column;
      min-height: 100vh; /* Full viewport height */
      font-family: Arial, sans-serif;
    }

    /* Ensure AppBar spans full width and stays on top */
    kendo-appbar.idocs-appbar {
      width: 100%;
      /* Optional if you want it fixed; otherwise your [positionMode]="'sticky'" is fine */
      /* position: sticky;
         top: 0; */
      z-index: 1000; /* Keep above other content */
    }

    /* Center the message in the remaining space */
    .content {
      flex: 1; /* Take up all remaining height below the header */
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px;
      text-align: center;
    }

    .message {
      max-width: 500px; /* Optional: limit width */
    }
    .message strong {
      display: block;
      font-size: 1.5em; /* Make first line bigger */
      margin-bottom: 10px;
    }

    /* Optional spacer if you need extra gap below the AppBar */
    .some-spacing {
      height: 8px;
    }
  </style>
</head>
<body>
  <kendo-appbar position="top" [positionMode]="'sticky'" [ngStyle]="headerStyle" class="idocs-appbar">
    <kendo-appbar-section>
      <!-- <button kendoButton [svgIcon]="icons.menuIcon" fillMode="flat" (click)="drawerAction($event)"></button> -->
    </kendo-appbar-section>

    <kendo-appbar-section class="title">
      <a routerLink="../home" (click)="navigate('icon-clicked')">
          <img src="/assets/img/iDocsXDPortal.png" width="50%" alt="iDocs Portal Logo">
      </a>
    </kendo-appbar-section>

    <kendo-appbar-spacer [width]="'70px'"></kendo-appbar-spacer>

    <kendo-appbar-section></kendo-appbar-section>
    <kendo-appbar-spacer></kendo-appbar-spacer>
    <kendo-appbar-section></kendo-appbar-section>
    <kendo-appbar-section></kendo-appbar-section>
  </kendo-appbar>

  <div class="some-spacing"></div>

  <!-- Centered area -->
  <div class="content">
    <div class="message">
      <strong>Access Denied to iDocsXD Portal</strong>
      <br>
      We're sorry, but it looks like you don't currently have access to the iDocsXD portal.<br>
      To request access, please reach out to your Document Management team.
    </div>
  </div>
</body>
</html>
